import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';

const styles = makeStyles(theme => ({
	image: {
		width: theme.spacing(2)
	},

	heightImage: {
		width: "auto",
		height: theme.spacing(2)
	}
}));

function SourceImage(props) {
	let	classes = styles(),
		{image, altText, backgroundColor, useHeight} = props;

	return (
		<img 
			src={image}
			alt={altText ? altText : 'Data source icon'}
			style={{backgroundColor: backgroundColor}}
			className={useHeight ? classes.heightImage : classes.image} />
	);
}

SourceImage.propTypes = {
	image: PropTypes.string,
	backgroundColor: PropTypes.string,
	altText: PropTypes.string,
	useHeight: PropTypes.bool
};

export default SourceImage;